import { render } from "./CustomerSurveyModal.vue?vue&type=template&id=23f4fd29"
import script from "./CustomerSurveyModal.vue?vue&type=script&lang=js"
export * from "./CustomerSurveyModal.vue?vue&type=script&lang=js"

import "./CustomerSurveyModal.vue?vue&type=style&index=0&id=23f4fd29&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__